enum RepMfrDataAccessStatus {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected',
  RevokedByRep = 'RevokedByRep',
  RevokedByMfr = 'RevokedByMfr'
}

export default RepMfrDataAccessStatus;
